// German for the dashboard: masthead, rail, the four zones and the delete-engagement modal.
import { registerDe } from '../i18n/index.js';

registerDe({
  // routeLabel
  'Below': 'Unten',
  'Open': 'Öffnen',
  'Timeline': 'Zeitachse',
  'Client': 'Kunde',
  'Documents': 'Dokumente',
  'Register': 'Register',
  'Agent': 'Agent',
  'Proposals': 'Vorschläge',
  'Contracting': 'Vertrag',
  'Acceptance': 'Abnahme',
  'Lifecycle': 'Lebenszyklus',
  'Portal admin': 'Portal-Verwaltung',
  // toasts
  'Nothing on this page is anchored at {id}.': 'Nichts auf dieser Seite ist bei {id} verankert.',
  'This item names a client surface but carries no client.': 'Dieser Eintrag nennt eine Kundenansicht, trägt aber keinen Kunden.',
  "No page is named '{screen}'.": 'Keine Seite heisst «{screen}».',
  '{code} deleted — {gone} went with it': '{code} gelöscht — {gone} gingen mit',
  '{code} deleted': '{code} gelöscht',
  '{code} archived — every row stays, it just leaves the active list': '{code} archiviert — jede Zeile bleibt, der Auftrag verlässt nur die aktive Liste',
  '{code} created': '{code} erstellt',
  // load failure
  'The dashboard brief could not be loaded': 'Das Dashboard-Briefing konnte nicht geladen werden',
  'The {path} endpoint answered: “{answer}”': 'Der Endpunkt {path} antwortete: «{answer}»',
  'no response': 'keine Antwort',
  // masthead
  'Dashboard': 'Dashboard',
  'signed in as': 'angemeldet als',
  'last here': 'zuletzt hier',
  'first visit': 'erster Besuch',
  'New engagement': 'Neuer Auftrag',
  // rail
  'Live': 'Aktiv',
  'Moves': 'Züge',
  'Clock': 'Uhr',
  'Ball': 'Ball',
  'New': 'Neu',
  // zone 1
  'Next move': 'Nächster Zug',
  'Ranked by the rule engine.': 'Gereiht durch die Regel-Engine.',
  'item; every one names its engagement and its screen.': 'Eintrag; er nennt seinen Auftrag und seinen Bildschirm.',
  'items; every one names its engagement and its screen.': 'Einträge; jeder nennt seinen Auftrag und seinen Bildschirm.',
  'Nothing in the queue — and the statement below names every gate it is claiming passes.': 'Nichts in der Warteschlange — und die Aussage unten nennt jedes Gate, das sie als bestanden beansprucht.',
  '{n} more, lower weight — {titles}': '{n} weitere, geringeres Gewicht — {titles}',
  'Show fewer': 'Weniger zeigen',
  'rule {rule} · w{weight}': 'Regel {rule} · w{weight}',
  'No move can be computed': 'Kein Zug berechenbar',
  'There is no live engagement on file, so no rule has a subject. Nothing can be gated, proposed or contracted until one exists.': 'Es ist kein aktiver Auftrag erfasst, also hat keine Regel ein Subjekt. Nichts kann durch ein Gate, vorgeschlagen oder vertraglich geregelt werden, bis einer existiert.',
  'proposed by the agent, not yet committed': 'vom Agenten vorgeschlagen, noch nicht übernommen',
  'derived check': 'abgeleitete Prüfung',
  // zone 2
  'The clocks': 'Die Uhren',
  'Dated obligations only — ours and theirs. An age with no date is a move, not a clock.': 'Nur datierte Verpflichtungen — unsere und ihre. Ein Alter ohne Datum ist ein Zug, keine Uhr.',
  'What': 'Was',
  'Due': 'Fällig',
  'Standing': 'Stand',
  'No clock is running': 'Keine Uhr läuft',
  'No milestone carries a due date, no acceptance record is issued and no commitment has a date against it. That is a real state, not a missing panel —': 'Kein Meilenstein trägt ein Fälligkeitsdatum, kein Abnahmeprotokoll ist ausgestellt und keine Zusage hat ein Datum. Das ist ein echter Zustand, kein fehlendes Panel —',
  'dated obligations exist.': 'datierte Verpflichtungen bestehen.',
  // zone 3
  'Moved without you': 'Ohne Sie bewegt',
  'Agent runs, portal actions and sign-offs. Your own edits are not news.': 'Agentenläufe, Portalaktionen und Freigaben. Ihre eigenen Änderungen sind keine Neuigkeit.',
  'Nothing has moved since you were last here': 'Seit Ihrem letzten Besuch hat sich nichts bewegt',
  'This is your first visit, so nothing can be new yet.': 'Dies ist Ihr erster Besuch, also kann noch nichts neu sein.',
  'The last': 'Die letzten',
  'thing that moved': 'Sache, die sich',
  'things that moved': 'Dinge, die sich',
  'without': 'ohne',
  'you:': 'Sie bewegt haben:',
  'Nothing has moved without you': 'Nichts hat sich ohne Sie bewegt',
  'No agent run has closed, no portal user has acted and no sign-off has been recorded': 'Kein Agentenlauf ist abgeschlossen, kein Portalnutzer hat gehandelt und keine Freigabe wurde erfasst',
  'since': 'seit',
  '— nothing has ever been recorded here': '— hier wurde noch nie etwas erfasst',
  'Your own edits are not listed here; you already know about those.': 'Ihre eigenen Änderungen stehen nicht hier; die kennen Sie bereits.',
  // zone 4
  'Engagements': 'Aufträge',
  'live': 'aktiv',
  'archived': 'archiviert',
  'Hide archived': 'Archivierte ausblenden',
  'Show archived': 'Archivierte zeigen',
  'No engagement on file': 'Kein Auftrag erfasst',
  'Signet keeps one register per engagement, and every gate, proposal and SOW hangs off one.': 'Signet führt ein Register pro Auftrag, und jedes Gate, jeder Vorschlag und jede SOW hängt an einem.',
  'The first move is already stated at the top of this page, with its route; it is not repeated here.': 'Der erste Zug steht bereits oben auf dieser Seite, mit seiner Route; er wird hier nicht wiederholt.',
  'There is no client on file either, and the engagement form needs one — so the first move is a client, not an engagement.': 'Es ist auch kein Kunde erfasst, und das Auftragsformular braucht einen — der erste Zug ist also ein Kunde, kein Auftrag.',
  // engagement row
  'Fixed price': 'Festpreis',
  'Time & materials': 'Nach Aufwand',
  'Capped T&M': 'Nach Aufwand mit Kostendach',
  'Retainer': 'Retainer',
  'last movement': 'letzte Bewegung vor',
  'd ago': 'Tagen',
  'More for {code}': 'Mehr zu {code}',
  'Open the lifecycle': 'Lebenszyklus öffnen',
  'Preview as client': 'Als Kunde ansehen',
  'Delete {code}…': '{code} löschen…',
  'Qualify': 'Qualifizierung',
  'Discovery': 'Discovery',
  'Design': 'Konzeption',
  'Mobilise': 'Mobilisierung',
  'Implement': 'Umsetzung',
  'Handover': 'Übergabe',
  'Close (phase)': 'Abschluss',
  'phase': 'Phase',
  'of': 'von',
  'automatic': 'automatisch',
  'manual': 'manuell',
  'gate': 'Gate',
  'the gate engine did not answer': 'die Gate-Engine hat nicht geantwortet',
  'tally unknown': 'Stand unbekannt',
  'documents': 'Dokumente',
  'register': 'Register',
  'agent': 'Agent',
  'proposals': 'Vorschläge',
  'contracting': 'Vertrag',
  'acceptance': 'Abnahme',
  // delete modal
  'Delete': 'Löschen',
  'cannot be deleted': 'kann nicht gelöscht werden',
  "for {client} goes, and so does everything recorded inside it. There is no undo and no archive to fall back on afterwards. Documents are client-owned — only this engagement's": 'für {client} geht, und mit ihm alles, was darin erfasst ist. Es gibt kein Rückgängig und kein Archiv, auf das man danach zurückfallen könnte. Dokumente gehören dem Kunden — nur die',
  'links': 'Verknüpfungen',
  'are removed; the files stay in the client library.': 'dieses Auftrags werden entfernt; die Dateien bleiben in der Kundenbibliothek.',
  'Nothing has been recorded against it yet.': 'Es wurde noch nichts dazu erfasst.',
  'The agent workspace under': 'Der Agent-Arbeitsbereich unter',
  'is removed too.': 'wird ebenfalls entfernt.',
  'An extraction run is using it right now, so it will be left in place and has to be cleared by hand.': 'Ein Extraktionslauf verwendet ihn gerade; er bleibt daher stehen und muss von Hand geleert werden.',
  'Type {token} to confirm': 'Geben Sie {token} ein, um zu bestätigen',
  'Cancel': 'Abbrechen',
  'Deleting…': 'Wird gelöscht…',
  'Delete {code} permanently': '{code} endgültig löschen',
  'Already archived': 'Bereits archiviert',
  'Archive instead': 'Stattdessen archivieren',
}, 'DashboardPage');
